import {
  API_GET_ACTIVE_PROMOTIONS_PENDING,
  API_GET_ACTIVE_PROMOTIONS_SUCCESS,
  API_GET_ACTIVE_PROMOTIONS_FAILURE,
  API_GET_PROMO_BY_ID_PENDING,
  API_GET_PROMO_BY_ID_SUCCESS,
  API_GET_PROMO_BY_ID_FAILURE,
  GET_PROMOTION_BY_SHORT_ID_PENDING,
  GET_PROMOTION_BY_SHORT_ID_SUCCESS,
  GET_PROMOTION_BY_SHORT_ID_FAILURE
} from '../actions/promotion/types';

export const initialState = {
  promotionById: {
    data: {},
    loading: false,
    error: null
  },
  activePromotion: {
    data: {},
    loading: false,
    error: null
  },
  promotionByShortId: {
    data: {},
    loading: false,
    error: null
  },
};

const promotionReducer = (state = initialState, action) => {
  switch (action.type) {
    case API_GET_ACTIVE_PROMOTIONS_PENDING:
      return { ...state, activePromotion: { ...state.activePromotion, loading: action.isLoading, error: null } };
    case API_GET_ACTIVE_PROMOTIONS_SUCCESS:
      return { ...state, activePromotion: { loading: action.isLoading, data: action.data, error: null } };
    case API_GET_ACTIVE_PROMOTIONS_FAILURE:
      return { ...state, activePromotion: { ...state.activePromotion, loading: action.isLoading, error: action.error } };
    case API_GET_PROMO_BY_ID_PENDING:
      return { ...state, promotionById: { ...state.promotionById, loading: action.isLoading, error: null } };
    case API_GET_PROMO_BY_ID_SUCCESS:
      return { ...state, promotionById: { loading: action.isLoading, data: action.data, error: null } };
    case API_GET_PROMO_BY_ID_FAILURE:
      return { ...state, promotionById: { ...state.promotionById, loading: action.isLoading, error: action.error } };
    case GET_PROMOTION_BY_SHORT_ID_PENDING:
      return { ...state, promotionByShortId: { ...state.promotionByShortId, loading: action.isLoading, error: null } };
    case GET_PROMOTION_BY_SHORT_ID_SUCCESS:
      return { ...state, promotionByShortId: { loading: action.isLoading, data: action.data, error: null } };
    case GET_PROMOTION_BY_SHORT_ID_FAILURE:
      return { ...state, promotionByShortId: { data: {}, loading: action.isLoading, error: action.error } };
    default:
      return state;
  }
};
export default promotionReducer;
